<template>
  <div
    class="section--container"
    :class="{
      'has-header': !!$slots['header-title'] || !!$slots['header-tools'],
      'has-footer': !!$slots['footer-title'] || !!$slots['footer-tools'],
      [type]: !!type
    }"
  >
    <!-- Header -->
    <div
      v-if="!!$slots['header-title'] || !!$slots['header-tools']"
      class="header"
    >
      <q-toolbar>
        <q-toolbar-title v-if="!!$slots['header-title']">
          <component
            :is="headerTitleTag"
            class="header--title text-weight-light text-lineheight-1 ellipsis text-h6"
          >
            <slot name="header-title" />
          </component>
        </q-toolbar-title>

        <!-- <q-space v-if="!!$slots['header-tools']" /> -->

        <div
          v-if="!!$slots['header-tools']"
          class="header--tools"
        >
          <slot name="header-tools" />
        </div>
      </q-toolbar>
    </div>

    <!-- Body -->
    <div
      class="body"
      :class="{
        'has-header': !!$slots['body-header-title'] || !!$slots['body-header-tools'],
        'has-footer': !!$slots['body-footer-title'] || !!$slots['body-footer-tools'],
        [type]: !!type
      }"
    >
      <div
        v-if="!!$slots['body-header-title'] || !!$slots['body-header-tools']"
        class="body--header"
      >
        <q-toolbar>
          <q-toolbar-title
            v-if="!!$slots['body-header-title']"
            class="body--header--title"
          >
            <slot name="body-header-title" />
          </q-toolbar-title>

          <q-space v-if="!!$slots['body-header-tools']" />

          <div
            v-if="!!$slots['body-header-tools']"
            class="body--header--tools"
          >
            <slot name="body-header-tools" />
          </div>
        </q-toolbar>
      </div>

      <div class="body--content">
        <q-scroll-area class="fit">
          <slot name="body" />
        </q-scroll-area>
      </div>

      <SanTransitionSlide is-vertical>
        <div
          v-if="!!$slots['body-footer-title'] || !!$slots['body-footer-tools']"
          class="body--footer"
        >
          <q-toolbar>
            <q-toolbar-title
              v-if="!!$slots['body-footer-title']"
              class="body--footer--title"
            >
              <slot name="body-footer-title" />
            </q-toolbar-title>

            <q-space v-if="!!$slots['body-footer-title'] && !!$slots['body-footer-tools']" />

            <div
              v-if="!!$slots['body-footer-tools']"
              class="body--footer--tools"
            >
              <slot name="body-footer-tools" />
            </div>
          </q-toolbar>
        </div>
      </SanTransitionSlide>
    </div>

    <!-- Footer -->
    <div
      v-if="!!$slots['footer-title'] || !!$slots['footer-tools']"
      class="footer"
    >
      <q-toolbar>
        <q-toolbar-title v-if="!!$slots['footer-title']">
          <component
            :is="footerTitleTag"
            class="footer--title"
          >
            <slot name="footer-title" />
          </component>
        </q-toolbar-title>

        <q-space v-if="!!$slots['footer-tools']" />

        <div
          v-if="!!$slots['footer-tools']"
          class="footer--tools"
        >
          <slot name="footer-tools" />
        </div>
      </q-toolbar>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'SanSectionContainer' })
const props = defineProps({
  headerTitleTag: { type: String, default: 'h1' },
  footerTitleTag: { type: String, default: 'h6' },
  bodyHeaderTitleTag: { type: String, default: 'h6' },
  bodyFooterTitleTag: { type: String, default: 'h6' },
  type: { type: String, default: null }
})
</script>
